import { Card, CardContent,Grid,IconButton,Typography } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import EditeIcon from '@mui/icons-material/Edit';
import './Style.css';
import { useContext, useState } from "react";
import { TodoContexts } from "../context/TodoContext";
import DeleteCommponent from "./DeleteCommponent";
import UpdateCommponentPop from "./UpdateCommponentPop";


export default function Todo({Todo,inpute}) {
  const {todoses,settodos}=useContext(TodoContexts);
  
  function handlCompletedButton(){
const Change=todoses.map((r)=>{
  if(Todo.id==r.id){
    r.isCompleted=!r.isCompleted
  }
  return r;
});
settodos(Change)
localStorage.setItem('todo',JSON.stringify(Change));
}

const [openupdate, setupdateOpen] =useState(false);
const handleupdateClickOpen = () => setupdateOpen(true);
const handleupdateClickClose = () => setupdateOpen(false);

const [open, setOpen] =useState(false);
const handleOpen = () => setOpen(true);
const handleClose = () => setOpen(false);
  
  function handlDeleteButton(){
const Del= todoses.filter((d)=>{
return d.id!=Todo.id;
});
settodos(Del);
localStorage.setItem('todo',JSON.stringify(Del));
handleClose();

}


    return (
       < >
      <Card variant="outlined" className="Card" >
<CardContent >

     <Grid container spacing={1}>
        <Grid size={8}>
      <Typography variant='h5' sx={{ textAlign:'right' }} style={{textDecoration:Todo.isCompleted?'line-through':'' }}>
        {Todo.title}
      </Typography>
      <Typography variant='h6' sx={{ textAlign:'right' }}>
        {Todo.details}
      </Typography>
        </Grid>
        <Grid size={4} display="flex" justifyContent="space-between" alignItems="center" >
        
        {/* CheckIconButton */}
        <IconButton aria-label="check" className={Todo.isCompleted?'checkso':'check'} 
        onClick={()=>{
           handlCompletedButton()
        }}
        >
  <CheckIcon />
</IconButton>
        {/* == CheckIconButton==  */}

        <IconButton aria-label="edit" className="edit" onClick={handleupdateClickOpen}>
  <EditeIcon />
</IconButton>

 <IconButton aria-label="delete"className="delete" onClick={handleOpen}>
  <DeleteIcon />
</IconButton>

{/* Promp Update */}
<UpdateCommponentPop  StateOpen={openupdate} Closeprop={handleupdateClickClose} Todo={Todo} />
{/* == Promp Update == */}

{/* Promp Delete */}
<DeleteCommponent handlDelete={handlDeleteButton} StateOpen={open} Closeprop={handleClose}/>
{/* == Promp Delete ==  */}

        </Grid>
      </Grid>
    


    </CardContent>

      </Card>
       </> 
    );
}
